import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClasseProfit } from '../models/ClasseProfit';

import { Step9 } from '../../../../shared/models/component-messages/blocCommun/mapa/step9';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';

@Component({
  selector: 'app-classe-profit',
  templateUrl: './classe-profit.component.html'
})
export class ClasseProfitComponent implements OnInit {
  constructor() {}
  @Input() uid = '';

  public current_uid = 'ClasseProfit';
  @Input() parentForm: FormGroup;
  @Input() classeProfit: ClasseProfit;
  @Input() disabled: boolean;

  public step9 = new Step9();

  public radioButtonValue: string;
  public radioButtonCtrlName: string;
  region = RadioCheckBoxEnum.region;
  departement = RadioCheckBoxEnum.departement;
  etat = RadioCheckBoxEnum.etat;
  debiteurEtranger = RadioCheckBoxEnum.debiteurEtranger;
  autresOrganismesPublics = RadioCheckBoxEnum.autresOrganismesPublics;
  debiteurPrivePersPhysique = RadioCheckBoxEnum.debiteurPrivePersPhysique;
  groupementCollectivites = RadioCheckBoxEnum.groupementCollectivites;
  commune = RadioCheckBoxEnum.commune;
  debiteurPrivePersMorale = RadioCheckBoxEnum.debiteurPrivePersMorale;
  etablissementsPublicsSante = RadioCheckBoxEnum.etablissementsPublicsSante;

  public ngOnInit() {
    if (this.classeProfit?.region === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.region;
    } else if (this.classeProfit?.departement === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.departement;
    } else if (this.classeProfit?.etat === RadioCheckBoxEnum.emptyValue ) {
      this.radioButtonValue = this.etat;
    } else if (this.classeProfit?.debiteurEtranger === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.debiteurEtranger;
    } else if (this.classeProfit?.autresOrganismesPublics === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.autresOrganismesPublics;
    } else if (this.classeProfit?.debiteurPrivePersPhysique === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.debiteurPrivePersPhysique;
    } else if (this.classeProfit?.groupementCollectivites === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.groupementCollectivites;
    } else if (this.classeProfit?.commune === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.commune;
    } else if (this.classeProfit?.debiteurPrivePersMorale === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.debiteurPrivePersMorale;
    } else if (this.classeProfit?.etablissementsPublicsSante === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.etablissementsPublicsSante;
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_region';
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
}
